export const campaignPhase = [
  {
    key: "pending",
    value: "Pending"
  },
  {
    key: "in-progress",
    value: "In Progress"
  },
  {
    key: "completed",
    value: "Completed"
  }
];